import React, { useState } from 'react';
import './Food.css';
import star from '../../../assets/Star.png'; 
import img1 from '../../../assets/offersforyou1.png';
import OfferDetailsModal from './OfferDetailsModal';
import axiosVendorInstance from '../../../axiosVendorInstance';
import OrderPopop from '../../../Components/OrderPopop';
import { useCart } from '../../../CartProvider';
import { HashLoader } from 'react-spinners';
import Loader from '../../../Components/Loader/Loader';
import locationIcon from '../../../assets/locationImg.svg';
import { SEO } from '../../../Utils/Constant';
import { Helmet } from 'react-helmet';

function Offer({ searchTerm, results, lastElementRef, loading }) {
    const validResults = results || [];
    const [selectedOffer, setSelectedOffer] = useState(null);
    const [open, setOpen] = useState(false);
    const [openPopup, setOpenPopup] = useState(false);
    const [vendorId, setVendorId] = useState(null);
    const [vendorName, setVendorName] = useState(null);
    const [vendorRating, setVendorRating] = useState(null);
    const [vendorAddress, setVendorAddress] = useState(null);
    const [vendorDistance, setVendorDistance] = useState(null);
    const [vendorRatingCount, setVendorRatingCount] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const {coordinate} = useCart();

    const handleClose = () => {
        setOpen(false);
        setSelectedOffer(null);
    };

    const fetchOfferDetails = async (offerId) => {
        try {
            setIsLoading(true);
            const response = await axiosVendorInstance.get(`/vendor/offers/offferbyid/${offerId}?userLat=${coordinate?.lat}&userLng=${coordinate?.lng}`,{skipAuth: true}); 
            setIsLoading(false);
            const data = response?.data?.offer;
            setSelectedOffer(data);
            setVendorId(data?.vendor_id);
            setVendorName(data?.vendor?.Name);
            setVendorRating(data?.vendor?.avg_rating);
            setVendorAddress(data?.vendor?.Address);
            setVendorDistance(data?.vendor?.distance_in_mile);
            setVendorRatingCount(data?.vendor?.Vendor_Review_User_Count);
            setOpen(true);
        } catch (error) {
            setIsLoading(false);
            console.error('Error fetching offer details:', error);
        }
    };

    const filteredOffers = validResults.filter((offers) =>
        offers?.Vendor_Name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleOrderClick = () => {
        setOpenPopup(!openPopup);
    };

    return (
        <div className="food-container-fake">
            <Helmet>
                <title>{SEO.OFFERS_PAGE.TITLE}</title>
                <meta name="description" content={SEO.OFFERS_PAGE.DESCRIPTION} />
                <meta name="keywords" content={SEO.OFFERS_PAGE.KEYWORDS} />
                <meta name="robots" content="index, follow" />
                                   
                <meta property="og:title" content={SEO.OFFERS_PAGE.TITLE} />
                <meta property="og:description" content={SEO.OFFERS_PAGE.DESCRIPTION} />
                <meta property="og:type" content={SEO.OFFERS_PAGE.OG.TYPE} />
                <meta property="og:site_name" content={SEO.OFFERS_PAGE.OG.SITE_NAME} />
                <meta property="og:image" content='https://omyfood.io/OMF_logo_bg.png' />
                                   
                <meta name="twitter:image" content='https://omyfood.io/OMF_logo_bg.png' />
                <meta name="twitter:title" content={SEO.OFFERS_PAGE.TWITTER.TITLE} />
                <meta name="twitter:description" content={SEO.OFFERS_PAGE.TWITTER.DESCRIPTION} />
                <meta
                    name="twitter:card"
                    content='summary_large_image'
                />
                        
            </Helmet>
            {isLoading && <Loader />}
            <div className="Food-Nearby-restaurants-cards-container">
                <div className="justify-content-center-2">
                    {filteredOffers?.length > 0 && (
                        filteredOffers?.map((offer, index) => {
                            const isLastElement = index === filteredOffers?.length - 1;
                            return(<div key={index} className="Food-search-restaurants-card" ref={isLastElement ? lastElementRef : null}>
                                <div className="img-and-offer-percentage" onClick={() => {
                                    fetchOfferDetails(offer?.OfferID);
                                }}>
                                    <img
                                        className="Food-search-restaurants-image"
                                        src={offer?.Offer_Avatar || img1}
                                        alt="Food img"
                                        onError={(e) => {
                                            e.target.src = img1; 
                                        }}
                                    />
                                    <h5 className="offer-percentage">{offer?.Offer_Percentage || 0}% OFF</h5>
                                </div>
                                <div className="Food-search-restaurants-content">
                                    <span className="Food-search-restaurants-text">
                                        {offer?.Vendor_Name}
                                    </span>
                                    <div className="Food-search-restaurant-footer">
                                        <div className="location-miles-container">
                                            <img 
                                                src={locationIcon} 
                                                alt="location" 
                                                style={{
                                                    width: '20px',
                                                    height: '20px'
                                                }}
                                            />
                                            <span className='Food-search-restaurant-dist'>
                                                {offer?.Distance_in_Miles?.toFixed(1)} miles
                                            </span>
                                        </div>
                                        <div className="Food-dist-layout">
                                            <img
                                                className="Food-search-rest-star-icon-image"
                                                src={star}
                                                alt="search-rest-star icon"
                                            />
                                            <span className="Food-search-rest-reviews">
                                                {(offer?.AvgRating ?? 0)?.toFixed(1)} ratings
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>);
                        })
                    )}
                </div>
                {filteredOffers.length === 0 && (
                    <h5 className="no-data-found">No Offer Found</h5>
                )}
            </div>
            {loading &&
                <div className='search-onload-loader'>
                    <HashLoader
                        color="#E13535"
                        loading={true}
                        size={50}
                    />
                </div>
            }

            {selectedOffer && (
                <OfferDetailsModal 
                    open={open} 
                    handleClose={handleClose}
                    handleOrderClick={handleOrderClick} 
                    offer={selectedOffer}
                    showOrderButton = {true}
                    vendorId={vendorId}
                    vendorDistance={vendorDistance}
                />
            )}
            <div>
                {openPopup && 
                    <OrderPopop
                        restaurantName={vendorName}
                        selectedOffer={selectedOffer}
                        handleClose={()=> {
                            setTimeout(() => {
                                setOpenPopup(!openPopup);
                            }, 500);
                        }}
                        vendorID={vendorId}
                        rating={vendorRating}
                        vendorAddress={vendorAddress}
                        vendorDistance={vendorDistance}
                        user_Rating_count={vendorRatingCount}
                    />
                }
            </div>
        </div>
    );
}

export default Offer;
